var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTriangleDowninline = function SvgTriangleDowninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.753 10.887a1.068 1.068 0 0 1-1.509 0L2.98 6.623a1.062 1.062 0 0 1-.23-1.163c.167-.4.553-.66.987-.66h8.53a1.07 1.07 0 0 1 .756 1.823l-4.265 4.264h-.004Z",
    fill: "#7C7C7C"
  }))));
};
export default SvgTriangleDowninline;